import { Amplify } from "aws-amplify";

export function initAmplify() {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolClientId: import.meta.env.VITE_COGNITO_USER_POOL_CLIENT_ID!,
        userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID!,
        identityPoolId: import.meta.env.VITE_COGNITO_IDENTITY_POOL_ID!,
      },
    },
  });
}
